import Alpine from 'alpinejs'
import anchor from '@alpinejs/anchor'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'

Alpine.plugin(anchor)
Alpine.plugin(collapse)
Alpine.plugin(focus)

window.Alpine = Alpine

import '@/scripts/stores'

import '@/scripts/modules/lenis'

import '@/scripts/modules/tracking'

import '@/scripts/modules/news_ajax'

/* Glob Imports */
import.meta.glob(['@/assets/**/*.{avif,gif,jpeg,jpg,png,svg,tiff,webp}', '!**/marker.svg'])
import.meta.glob(['../../components/**/*.js'], { eager: true })
import.meta.glob(['../../blocks/**/*.js'], { eager: true })

//import.meta.glob(['./modules/tracking.js'], { eager: true })
import bladesDynamicClipPath from './modules/blades'  
import './modules/scroll-shadow'

document.addEventListener('DOMContentLoaded', () => {
  Alpine.start()
  bladesDynamicClipPath()
}, { once: true })

